




















import { Component, Vue } from "vue-property-decorator";
import CardMenu from "../../components/CardMenu.vue";
import TranslationApiAgent from "../../services/translation-api-agent";
import Editor from '../../components/Editor.vue';
import ProgramsApiAgent from '@/services/programs-api-agent';
import { format } from 'date-fns';

// @ts-ignore
@Component()
export default class AdminNewsEdit extends Vue {
	private sendStr: string = this.translationsApiAgent.get('send');
	private titleStr: string = this.translationsApiAgent.get('admin::page::title');
	private response: string = '';

	private title: string = '';
  private from: string = '';
  private to: string = '';

  constructor(
    private programsApiAgent = ProgramsApiAgent,
		private translationsApiAgent = TranslationApiAgent
  ) {
    super();
	}

	get id() {
		return this.$route.params.id;
	}

	get isNew() {
		return this.id === 'new';
  }

  get fromDate() {
    return new Date(this.from);
  }

  get invalidFrom() {
    return this.from === '';
  }

  get toDate() {
    return this.to === '' ? new Date(-3600000) : new Date(this.to);
  }

  mounted() {
		if (!this.isNew) {
			this.programsApiAgent.getAll().then(result => {
        const item = result.find(n => n.id === Number.parseInt(this.id));
        this.title = item.content;
        this.from = this.formatDate(item.from);
        if (item.to.getTime() > 0) {
          this.to = this.formatDate(item.to);
        }
			});
		}
	}

	private remove() {
		const answer = confirm(this.translationsApiAgent.get('admin::remove-question'));
		if (answer) {
			this.programsApiAgent.remove(this.id).then(result => {
				this.$router.push({
					path: '/admin/programs'
				});
			});
		}
	}

	private send() {
    if (this.invalidFrom) {
      return;
    }
		if (this.isNew) {
			this.programsApiAgent.add(this.title, this.fromDate, this.toDate).then(result => {
				if (result) {
					this.$router.push({
						path: '/admin/programs/' + result.result
					});
				}
			});
		}
		else {
			this.programsApiAgent.update(this.id, this.title, this.fromDate, this.toDate).then(result => {
				this.response = this.translationsApiAgent.get(result ? 'admin::save-success' : 'admin::save-fail');
			});
		}
  }

  private formatDate(date: Date) {
    return format(date, 'YYYY-MM-DDTHH:mm');
  }
}
